import { Breakpoints } from "@hova-labs/bento-box-web";

export const breakpoints: Breakpoints = {
  s: 0,
  m: 321,
  l: 769,
  xl: 1281,
};
